import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';

function OutlineTextField(props) {
    return (
        <OutlinedInput
            margin="none"
            variant="outlined"
            color="secondary"
            onChange={props.onChange}
            onBlur={props.onChange}
            inputProps={{
                ...props.inputProps
            }}            
            {...props}
        />
    ); 
}

export default OutlineTextField;